/**
 * Conversion factors worth offering as one-click presets in the dimensional-analysis tool.
 *
 * Each is `leftValue leftUnit = rightValue rightUnit`. Every one is exact by definition:
 * the international inch (2.54 cm), foot, yard and mile (1,609.344 m), the avoirdupois
 * pound (0.453 592 37 kg) and ounce (28.349 523 125 g), the US gallon
 * (3.785 411 784 L), the thermochemical calorie (4.184 J), the standard atmosphere
 * (101 325 Pa = 760 Torr), the bar (10⁵ Pa), and the Avogadro constant
 * (6.022 140 76 × 10²³ mol⁻¹) since the 2019 SI redefinition. The metric prefixes and
 * clock units are definitions too.
 */

export interface CommonFactor {
  id: string;
  leftValue: string;
  leftUnit: string;
  rightValue: string;
  rightUnit: string;
}

const f = (
  id: string,
  leftValue: string,
  leftUnit: string,
  rightValue: string,
  rightUnit: string
): CommonFactor => ({ id, leftValue, leftUnit, rightValue, rightUnit });

export const COMMON_FACTORS: readonly CommonFactor[] = [
  f("in-cm", "1", "in", "2.54", "cm"),
  f("ft-in", "1", "ft", "12", "in"),
  f("yd-ft", "1", "yd", "3", "ft"),
  f("mi-ft", "1", "mi", "5280", "ft"),
  f("mi-m", "1", "mi", "1609.344", "m"),
  f("m-cm", "1", "m", "100", "cm"),
  f("km-m", "1", "km", "1000", "m"),
  f("kg-g", "1", "kg", "1000", "g"),
  f("g-mg", "1", "g", "1000", "mg"),
  f("lb-kg", "1", "lb", "0.45359237", "kg"),
  f("oz-g", "1", "oz", "28.349523125", "g"),
  f("L-mL", "1", "L", "1000", "mL"),
  f("gal-L", "1", "gal", "3.785411784", "L"),
  f("h-min", "1", "h", "60", "min"),
  f("min-s", "1", "min", "60", "s"),
  f("day-h", "1", "day", "24", "h"),
  f("cal-J", "1", "cal", "4.184", "J"),
  f("atm-Pa", "1", "atm", "101325", "Pa"),
  f("atm-Torr", "1", "atm", "760", "Torr"),
  f("bar-Pa", "1", "bar", "100000", "Pa"),
  f("mol-N", "1", "mol", "6.02214076e23", "particles"),
];
